import * as XLSX from "xlsx";

// Uma aba "Dados", com as linhas na ordem em que estão na tela.
export function exportarExcel(linhas, colunas, arquivo) {
  const dados = linhas.map((linha, i) => {
    const obj = {};
    colunas.forEach((c) => { obj[c.header] = c.value(linha, i); });
    return obj;
  });
  const ws = XLSX.utils.json_to_sheet(dados);
  ws["!cols"] = colunas.map((c) => ({ wch: Math.max(c.header.length + 2, 15) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Dados");
  XLSX.writeFile(wb, arquivo);
}
